import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    activeVCs: [
        {
            id: 1,
            investorName: 'James Whitaker',
            email: 'james@forgecapital.com',
            vcName: 'Forge Capital',
            industry: ["AI_MACHINE_LEARNING", "SOCIAL_NETWORKING"],
            startupStage: ["IDEA",],
            teamMember: '3',
            plan: 'Monthly Plan',
            nextBillingDate: "September 2, 2024",
            dateRegistered: "September 2, 2024",
            lastActive: "April 2, 2024"
        },
        {
            id: 2,
            investorName: "Olivia Hastings",
            email: "olivia@gmail.com",
            vcName: 'Northbeam Ventures',
            industry: ["SOCIAL_NETWORKING", "AI_MACHINE_LEARNING"],
            startupStage: ["MVP",],
            teamMember: '5',
            plan: 'Yearly Plan',
            nextBillingDate: "May 3, 2024",
            dateRegistered: "May 3, 2024",
            lastActive: "May 3, 2024"
        },
        {
            id: 3,
            investorName: "Brandon Cole",
            email: "brandon@gmail.com",
            vcName: 'Crimson Peak Partners',
            industry: ["CYBERSECURITY"],
            startupStage: ["MVP",],
            teamMember: '3',
            plan: 'Monthly Plan',
            nextBillingDate: "April 29, 2024",
            dateRegistered: "April 29, 2024",
            lastActive: "April 29, 2024"
        },
        {
            id: 4,
            investorName: "Sophia Klein",
            email: "sophia@gmail.com",
            vcName: 'Orbit Lane Capital',
            industry: ["AI_MACHINE_LEARNING", 'CYBERSECURITY'],
            startupStage: ["PRE_SEED",],
            teamMember: '1',
            plan: 'Monthly Plan',
            nextBillingDate: "April 17, 2024",
            dateRegistered: "April 17, 2024",
            lastActive: "April 17, 2024"
        },
        {
            id: 5,
            investorName: "Ethan Morales",
            email: "ethan@gmail.com",
            vcName: 'Stonewave Ventures',
            industry: ["TRANSPORT_MOBILITY", "CYBERSECURITY", 'AI_MACHINE_LEARNING'],
            startupStage: ["IDEA",],
            teamMember: '3',
            plan: 'Yearly Plan',
            nextBillingDate: "May 16, 2024",
            dateRegistered: "May 16, 2024",
            lastActive: "May 16, 2024"
        },
        {
            id: 6,
            investorName: "Madison Lee",
            email: "madison@gmail.com",
            vcName: 'Lumen Theory',
            industry: ["E_COMMERCE_RETAIL"],
            startupStage: ["MVP", "SERIES_A"],
            teamMember: '8',
            plan: 'Monthly Plan',
            nextBillingDate: "June 1, 2024",
            dateRegistered: "June 1, 2024",
            lastActive: "June 1, 2024"
        },
        {
            id: 7,
            investorName: "Dylan Prescott",
            email: "dylan@gmail.com",
            vcName: 'Bluegrain Capital',
            industry: ["CYBERSECURITY"],
            startupStage: ["SERIES_A", "MVP", "SERIES_B"],
            teamMember: '3',
            plan: 'Monthly Plan',
            nextBillingDate: "April 17, 2024",
            dateRegistered: "April 17, 2024",
            lastActive: "April 17, 2024"
        },
        {
            id: 8,
            investorName: "Isabella Novak",
            email: "isabella@gmail.com",
            vcName: 'EchoVale Ventures',
            industry: ["GAMING_ENTERTAINMENT"],
            startupStage: ["SERIES_B",],
            teamMember: '2',
            plan: 'Monthly Plan',
            nextBillingDate: "April 21, 2024",
            dateRegistered: "April 21, 2024",
            lastActive: "April 21, 2024"
        },
        {
            id: 9,
            investorName: "Marcus Bell",
            email: "marcus@gmail.com",
            vcName: 'Holloway & Rise',
            industry: ["HEALTH_BIOTECH"],
            startupStage: ["PRE_SEED",],
            teamMember: '4',
            plan: 'Monthly Plan',
            nextBillingDate: "April 29, 2024",
            dateRegistered: "April 29, 2024",
            lastActive: "April 29, 2024"
        },
        {
            id: 10,
            investorName: "Chloe Ramsey",
            email: "chloe@gmail.com",
            vcName: 'Zephyr Bridge Capital',
            industry: ["AI_MACHINE_LEARNING"],
            startupStage: ["IDEA",],
            teamMember: '6',
            plan: 'Monthly Plan',
            nextBillingDate: "July 13, 2024",
            dateRegistered: "July 13, 2024",
            lastActive: "July 13, 2024"
        },
    ],
    notCompletedVCs: [
        {
            id: 1,
            investorName: 'James Whitaker',
            email: 'james@forgecapital.com',
            vcName: 'Forge Capital',
            industry: ["AI_MACHINE_LEARNING", "SOCIAL_NETWORKING"],
            startupStage: ["IDEA",],
            teamMember: '3',
            plan: 'Monthly Plan',
            nextBillingDate: "September 2, 2024",
            dateRegistered: "September 2, 2024",
            lastActive: "April 2, 2024"
        },
        {
            id: 2,
            investorName: "Olivia Hastings",
            email: "olivia@gmail.com",
            vcName: 'Northbeam Ventures',
            industry: ["SOCIAL_NETWORKING", "AI_MACHINE_LEARNING"],
            startupStage: ["MVP",],
            teamMember: '5',
            plan: 'Yearly Plan',
            nextBillingDate: "May 3, 2024",
            dateRegistered: "May 3, 2024",
            lastActive: "May 3, 2024"
        },
        {
            id: 3,
            investorName: "Brandon Cole",
            email: "brandon@gmail.com",
            vcName: 'Crimson Peak Partners',
            industry: ["CYBERSECURITY"],
            startupStage: ["MVP",],
            teamMember: '3',
            plan: 'Monthly Plan',
            nextBillingDate: "April 29, 2024",
            dateRegistered: "April 29, 2024",
            lastActive: "April 29, 2024"
        },
        {
            id: 4,
            investorName: "Sophia Klein",
            email: "sophia@gmail.com",
            vcName: 'Orbit Lane Capital',
            industry: ["AI_MACHINE_LEARNING", 'CYBERSECURITY'],
            startupStage: ["PRE_SEED",],
            teamMember: '1',
            plan: 'Monthly Plan',
            nextBillingDate: "April 17, 2024",
            dateRegistered: "April 17, 2024",
            lastActive: "April 17, 2024"
        },
        {
            id: 5,
            investorName: "Ethan Morales",
            email: "ethan@gmail.com",
            vcName: 'Stonewave Ventures',
            industry: ["TRANSPORT_MOBILITY", "CYBERSECURITY", 'AI_MACHINE_LEARNING'],
            startupStage: ["IDEA",],
            teamMember: '3',
            plan: 'Yearly Plan',
            nextBillingDate: "May 16, 2024",
            dateRegistered: "May 16, 2024",
            lastActive: "May 16, 2024"
        },
        {
            id: 6,
            investorName: "Madison Lee",
            email: "madison@gmail.com",
            vcName: 'Lumen Theory',
            industry: ["E_COMMERCE_RETAIL"],
            startupStage: ["MVP", "SERIES_A"],
            teamMember: '8',
            plan: 'Monthly Plan',
            nextBillingDate: "June 1, 2024",
            dateRegistered: "June 1, 2024",
            lastActive: "June 1, 2024"
        },
        {
            id: 7,
            investorName: "Dylan Prescott",
            email: "dylan@gmail.com",
            vcName: 'Bluegrain Capital',
            industry: ["CYBERSECURITY"],
            startupStage: ["SERIES_A", "MVP", "SERIES_B"],
            teamMember: '3',
            plan: 'Monthly Plan',
            nextBillingDate: "April 17, 2024",
            dateRegistered: "April 17, 2024",
            lastActive: "April 17, 2024"
        },
        {
            id: 8,
            investorName: "Isabella Novak",
            email: "isabella@gmail.com",
            vcName: 'EchoVale Ventures',
            industry: ["GAMING_ENTERTAINMENT"],
            startupStage: ["SERIES_B",],
            teamMember: '2',
            plan: 'Monthly Plan',
            nextBillingDate: "April 21, 2024",
            dateRegistered: "April 21, 2024",
            lastActive: "April 21, 2024"
        },
        {
            id: 9,
            investorName: "Marcus Bell",
            email: "marcus@gmail.com",
            vcName: 'Holloway & Rise',
            industry: ["HEALTH_BIOTECH"],
            startupStage: ["PRE_SEED",],
            teamMember: '4',
            plan: 'Monthly Plan',
            nextBillingDate: "April 29, 2024",
            dateRegistered: "April 29, 2024",
            lastActive: "April 29, 2024"
        },
        {
            id: 10,
            investorName: "Chloe Ramsey",
            email: "chloe@gmail.com",
            vcName: 'Zephyr Bridge Capital',
            industry: ["AI_MACHINE_LEARNING"],
            startupStage: ["IDEA",],
            teamMember: '6',
            plan: 'Monthly Plan',
            nextBillingDate: "July 13, 2024",
            dateRegistered: "July 13, 2024",
            lastActive: "July 13, 2024"
        },
    ],
    suspenedVCs: [
        {
            id: 1,
            investorName: 'James Whitaker',
            email: 'james@forgecapital.com',
            vcName: 'Forge Capital',
            industry: ["AI_MACHINE_LEARNING", "SOCIAL_NETWORKING"],
            startupStage: ["IDEA","MVP","PRE_SEED"],
            teamMember: '3',
            plan: 'Monthly Plan',
            nextBillingDate: "September 2, 2024",
            dateRegistered: "September 2, 2024",
            suspendedDate: "April 2, 2024"
        },
        {
            id: 2,
            investorName: "Olivia Hastings",
            email: "olivia@gmail.com",
            vcName: 'Northbeam Ventures',
            industry: ["SOCIAL_NETWORKING", "AI_MACHINE_LEARNING"],
            startupStage: ["MVP",],
            teamMember: '5',
            plan: 'Yearly Plan',
            nextBillingDate: "May 3, 2024",
            dateRegistered: "May 3, 2024",
            suspendedDate: "May 3, 2024"
        },
        {
            id: 3,
            investorName: "Brandon Cole",
            email: "brandon@gmail.com",
            vcName: 'Crimson Peak Partners',
            industry: ["CYBERSECURITY"],
            startupStage: ["MVP","PRE_SEED"],
            teamMember: '3',
            plan: 'Monthly Plan',
            dateRegistered: "April 29, 2024",
            suspendedDate: "April 29, 2024"
        },
        {
            id: 4,
            investorName: "Sophia Klein",
            email: "sophia@gmail.com",
            vcName: 'Orbit Lane Capital',
            industry: ["AI_MACHINE_LEARNING", 'CYBERSECURITY'],
            startupStage: ["PRE_SEED",],
            teamMember: '1',
            plan: 'Monthly Plan',
            nextBillingDate: "April 17, 2024",
            dateRegistered: "April 17, 2024",
            suspendedDate: "April 17, 2024"
        },
        {
            id: 5,
            investorName: "Ethan Morales",
            email: "ethan@gmail.com",
            vcName: 'Stonewave Ventures',
            industry: ["TRANSPORT_MOBILITY", "CYBERSECURITY", 'AI_MACHINE_LEARNING'],
            startupStage: ["IDEA",],
            teamMember: '3',
            plan: 'Yearly Plan',
            nextBillingDate: "May 16, 2024",
            dateRegistered: "May 16, 2024",
            suspendedDate: "May 16, 2024"
        },
        {
            id: 6,
            investorName: "Madison Lee",
            email: "madison@gmail.com",
            vcName: 'Lumen Theory',
            industry: ["E_COMMERCE_RETAIL"],
            startupStage: ["MVP",],
            teamMember: '8',
            plan: 'Monthly Plan',
            nextBillingDate: "June 1, 2024",
            dateRegistered: "June 1, 2024",
            suspendedDate: "June 1, 2024"
        },
        {
            id: 7,
            investorName: "Dylan Prescott",
            email: "dylan@gmail.com",
            vcName: 'Bluegrain Capital',
            industry: ["CYBERSECURITY"],
            startupStage: ["SERIES_A","MVP"],
            teamMember: '3',
            plan: 'Monthly Plan',
            nextBillingDate: "April 17, 2024",
            dateRegistered: "April 17, 2024",
            suspendedDate: "April 17, 2024"
        },
        {
            id: 8,
            investorName: "Isabella Novak",
            email: "isabella@gmail.com",
            vcName: 'EchoVale Ventures',
            industry: ["GAMING_ENTERTAINMENT"],
            startupStage: ["SERIES_B",],
            teamMember: '2',
            plan: 'Monthly Plan',
            nextBillingDate: "April 21, 2024",
            dateRegistered: "April 21, 2024",
            suspendedDate: "April 21, 2024"
        },
        {
            id: 9,
            investorName: "Marcus Bell",
            email: "marcus@gmail.com",
            vcName: 'Holloway & Rise',
            industry: ["HEALTH_BIOTECH"],
            startupStage: ["PRE_SEED","SERIES_A","SERIES_B","MVP"],
            teamMember: '4',
            plan: 'Monthly Plan',
            nextBillingDate: "April 29, 2024",
            dateRegistered: "April 29, 2024",
            suspendedDate: "April 29, 2024"
        },
        {
            id: 10,
            investorName: "Chloe Ramsey",
            email: "chloe@gmail.com",
            vcName: 'Zephyr Bridge Capital',
            industry: ["AI_MACHINE_LEARNING"],
            startupStage: ["IDEA",],
            teamMember: '6',
            plan: 'Monthly Plan',
            nextBillingDate: "July 13, 2024",
            dateRegistered: "July 13, 2024",
            suspendedDate: "July 13, 2024"
        },
    ],
    singleVc: {
        id: 1,
        name: 'Aviv Gafni',
        jobTitle: 'Managing Partner, Hyperwise Ventures',
        linkedinProfile: 'https://www.linkedin.com/tyler-grayson',
        bio: 'Aviv is an angel investor and entrepreneur with more than 10 years of experience in the field of cyber security.Prior to turning investor, Aviv co-founded Hyperwise Security that pioneered a groundbreaking CPU-Level detection technology, which was acquired by Check Point in 2/2015.Between 2015 – 2019, while with Check Point, Aviv lead the advanced cyber security ideation process, and pioneered, researched and developed groundbreaking technologies, helping Check Point to deliver the most innovative security technologies to its customers. In addition to his architect role, Aviv served as an expert advisor to Dr. Dorit Dor, the VP Products of Check Point, advising on various cyber security ideas and challenges.',
        investedIn: 'Pontera, IONIX, Dealtable, Argon, Speedb',
        easySchedulingUrl: 'https://www.calendly.com/james-whitaker',
        vc: {
            name: 'Hyperwise Ventures',
            aboutInvestor: 'We are the only early stage venture capital in which we, the 3 managing partners have founded, built and managed a successful cybersecurity startup (Hyperwise Security).',
            startUpInvested: 'Pontera, IONIX, Dealtable, Argon, Speedb',
            industries: '🤖 🤖 AI & Machine Learning 🔒 🔒 Cybersecurity',
            startupStage: ['💡 IDEA MVP 🌱 PRE_SEED 🌿 SEED',],
            linkedinPage: 'https://www.linkedin.com/uniqum',
            website: 'https://www.uniqum.ai',
        },
        billingDetail: [
            {
                status: 'Success',
                amount: '($130 USD)',
                duration: 'Month Day, Year'
            },
            {
                status: 'Failed',
                amount: '($130 USD)',
                duration: 'Month Day, Year'
            },
            {
                status: 'Refund',
                amount: '($130 USD)',
                duration: 'Month Day, Year'
            },
        ],
        adminHistory: [
            {
                reportNumber: 'Changed: Personal Email Address',
                time: '14.58'
            },
            {
                reportNumber: 'Changed: University Email Address',
                time: '14.52'
            },
            {
                reportNumber: 'Restored: Reason',
                time: '14.10'
            },
            {
                reportNumber: 'Suspended: Reason',
                time: '13.50'
            },
        ],
        report: {
            reportList: [
                {
                    reportNumber: 'Report #230',
                    time: '14.58'
                },
                {
                    reportNumber: 'Report #117',
                    time: '14.58'
                },
            ]
        },
        activity: {
            totalHours: '14.2',
            average: '21.4',
            activityList: [
                {
                    name: 'Greg Anderson',
                    time: '14.28'
                },
                {
                    name: 'Joseph Brad',
                    time: '14.23'
                },
                {
                    name: 'Tyler Cohen',
                    time: '14.54'
                },
                {
                    name: 'James Madlin',
                    time: '14.50'
                },
            ]
        },
    },
};

const vcSlice = createSlice({
    name: 'vcs',
    initialState,
    reducers: {
        setActiveVCs: (state, action) => {
            state.activeVCs = action.payload;
        },
        setNotCompletedVCs: (state, action) => {
            state.notCompletedVCs = action.payload;
        },
        setSuspendedVCs: (state, action) => {
            state.suspenedVCs = action.payload;
        },
        setSingleVCs: (state, action) => {
            state.singleVc = action.payload;
        },
    },
});

export const {
    setActiveVCs,
    setNotCompletedVCs,
    setSuspendedVCs,
    setSingleVCs
} = vcSlice.actions;

export default vcSlice.reducer;